import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { ErrorBoundary } from "../containers/ErrorBoundary";

const Layout: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex h-screen w-full bg-vGray100 overflow-hidden">
      {/* Sidebar - fixed dark panel */}
      <div className="sticky top-0 h-screen flex-shrink-0 p-4">
        <Sidebar />
      </div>

      {/* Main content area - no widget container */}
      <div className="flex flex-1 flex-col min-w-0">
        {/* Topbar */}
        <div className="flex-shrink-0 p-4">
          <Topbar />
        </div>

        {/* Page content */}
        <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-neutral-400 scrollbar-track-transparent p-8">
          <div className="mx-auto w-full max-w-[1600px]">
            {/* A crash in one page keeps the sidebar; navigating away clears it */}
            <ErrorBoundary resetKey={pathname}>
              <Outlet />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
